import React from "react";


class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.promoNA = this.props.promoNA;
  }

  getText(item) {
    return this.promoNA === true ?
      (item.pna === undefined ? item.text : item.pna)
      : item.text;
    //return ret; 
  }
  getFooter() {
    return this.promoNA === true ? '' :
        this.props.footer === undefined ? '' : this.props.footer.promoText;
  }

  render() {
    return (
      <div className="card mb-4 shadow-sm">
        <div className="card-header list-group-item-primary">
          <h5 className="my-0 font-weight-normal">{this.props.title}</h5>
        </div>
        <div className="card-body">
          {this.props.items.map((c, index) =>
            <div key={index.toString()} className="card-title pricing-card-title text-muted"
              dangerouslySetInnerHTML={{ __html: this.getText(c) }}>
            </div>
          )}
          <small className='card-text text-muted font-italic'>
            {this.getFooter()}
          </small>
        </div>
      </div>
    );

  }
}

/*
function Banner(props) {
  console.log(`Banner :: promoNA`, props.promoNA);
  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-header">
        <h5 className="my-0 font-weight-normal">{props.title}</h5>
      </div>
      <div className="card-body">
        {props.items.map((c, index) =>
          <div key={index.toString()} className="card-title pricing-card-title text-muted"
            dangerouslySetInnerHTML={{__html: c.text}}>
          </div>
        )}
      </div>
    </div>
  );
}
*/



export default Banner;

/*
function Banner(props) {
  return (
    <div className="card mb-4 shadow-sm">
      <div className="card-header">
        <h5 className="my-0 font-weight-normal">{props.title}</h5>
      </div>
      <div className="card-body">
        {props.items.map((c, index) =>
          <h6 key={index.toString()} className="card-title pricing-card-title text-muted">
            {c.text}
          </h6>
        )}
      </div>
    </div>
  );
*/